// @flow
import { css } from 'styled-components';

function createMediaQuery(width: number) {
  // TODO: use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  // const emSize = width / 16;

  return (...args: any[]) => css`
    @media (min-width: ${width}px) {
      ${css(...args)};
    }
  `;
}

export const media = Object.freeze({
  lg: createMediaQuery(1200),
  md: createMediaQuery(992),
  sm: createMediaQuery(768),
  xs: createMediaQuery(480),
});

export default media;



// WEBPACK FOOTER //
// ./src/themes/media.js